







































import { Component, Vue, Prop } from "vue-property-decorator";
import { ia_agent } from "@/shared/classes/ia_agents_store";

@Component({
  components: {},
})
export default class ia_agent_item extends Vue {
  @Prop({ required: true }) public agent!: ia_agent;

  public emitUse(): void {
    this.$emit("use", this.agent);
  }
}
